import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-warning-modal',
  templateUrl: './warning-modal.component.html',
  styleUrls: ['./warning-modal.component.scss'],
})
export class WarningModalComponent {
  @Input() bannerText: string;
  @Input() headerIcon: string;
  @Input() headerIconColor: string;
  @Input() headerIconSize: string;
  @Input() headerText: string;
  @Input() bodyText: BodyText[];
  @Input() proceedButtonText: string;
  @Input() dismissButtonText: string;
  @Output() proceedEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() dismissEvent: EventEmitter<void> = new EventEmitter<void>();
}

export interface BodyText {
  text: string;
  icon?: string;
  onClick?: () => Promise<any>;
}
